import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AnimatedBackground from './components/ui/AnimatedBackground';
import CherryBlossomParticles from './components/ui/CherryBlossomParticles';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import './App.css';

function App() {
  const handleParticleClick = (points: number, x: number, y: number) => {
    // Convert document coordinates to viewport coordinates for the animation
    const viewportX = x;
    const viewportY = y - window.scrollY;
    
    // Dispatch a custom event that ScoreCounter can listen to
    const event = new CustomEvent('particleClick', { 
      detail: { points, viewportX, viewportY } 
    });
    window.dispatchEvent(event);
  };

  return (
    <Router>
      <div className="App min-h-screen relative overflow-x-hidden">
        <AnimatedBackground />
        <div className="relative z-10">
          <Header />
          <main className="flex-grow pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <CherryBlossomParticles onParticleClick={handleParticleClick} />
        </div>
      </div>
    </Router>
  );
}

export default App; 